import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";

interface iUserCreditBalanceListResponse {
    items: [{
        user_id: string;
        free_available: number;
        free_held: number;
        paid_available: number;
        paid_held: number;
        updated_at_iso: string;
    }],
    next_cursor: number | null;
    has_more: boolean;
}

export interface iUserCreditBalanceListState {
    response: iUserCreditBalanceListResponse | null;
    cursorStack: (number | null)[];  // ← 히스토리 스택
    currentPage: number;
    isLoading: boolean;
    message: string | null;
}

const initialState: iUserCreditBalanceListState = {
    response: null,
    cursorStack: [null],  // ← 첫 페이지 cursor=null
    currentPage: 0,
    isLoading: false,
    message: null,
}

export const getUserCreditBalanceListAPI = createAsyncThunk(
    "GET_USER_CREDIT_BALANCE_LIST",
    async (params: { limit: number; cursor?: number | null; user_email?: string }, { rejectWithValue }) => {
        const djangoEndpoint = getDjangoEndpoint();
        const pathParam = '/A7fQ9K2mXcP4R8sL/admin/user-balance-list/';
        try {
            const response = await axios.get(`${djangoEndpoint}${pathParam}`, {
                withCredentials: true,
                params: {
                    ...(params.limit && { limit: params.limit }),
                    ...(params.cursor != null && { cursor: params.cursor }),
                    ...(params.user_email && { user_email: params.user_email }),
                },
            });
            return response.data;
        } catch (e) {
            console.error('User Credit Balance List API 에러:', e);
            return rejectWithValue(e.response ? e.response.data : e.message);
        }
    }
)

export const userCreditBalanceListSlice = createSlice({
    name: 'userCreditBalanceList',
    initialState,
    reducers: {
        goNextPage: (state) => {
            if (state.response?.has_more) {
                state.cursorStack.push(state.response.next_cursor);
                state.currentPage += 1;
            }
        },
        goPrevPage: (state) => {
            if (state.currentPage > 0) {
                state.cursorStack.pop();
                state.currentPage -= 1;
            }
        },
        resetPagination: (state) => {
            state.cursorStack = [null];
            state.currentPage = 0;
        },
    },
    extraReducers: (builder) => {
        builder
        .addCase(getUserCreditBalanceListAPI.pending, (state) => {
            state.isLoading = true;
            state.message = null;
        })
        .addCase(getUserCreditBalanceListAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.response = action.payload;
        })
        .addCase(getUserCreditBalanceListAPI.rejected, (state, action) => {
            state.isLoading = false;
            state.message = action.payload as string;
        })
    }
})

export const { goNextPage, goPrevPage, resetPagination } = userCreditBalanceListSlice.actions;
export default userCreditBalanceListSlice.reducer;
